import type { Moment } from 'moment'
import moment from 'moment'
import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import BodyText from 'LuxKit/Typography/BodyText'
import { SHORT_DAY_NAME_DAY_MONTH_YEAR } from 'constants/dateFormats'
import { useRegionTimeFormat } from 'hooks/useRegionTimeFormat'

interface Props {
  startDate: Moment | undefined
  endDate: Moment | undefined
  startTime: Moment | undefined
  endTime: Moment | undefined
  isAccommodation: boolean
}

const Dates = styled.div`
  display: flex;
  width: 100%;
`

const Date = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

function CheckInAndOutDate({
  startDate,
  endDate,
  startTime,
  endTime,
  isAccommodation,
}: Props) {
  const intl = useIntl()
  const timeFormat = useRegionTimeFormat()

  const checkInLabel = intl.formatMessage({
    id: 'RP8xfsTAwq',
    defaultMessage: 'Check in',
    description: 'Label for accommodation check-in date',
  })
  const startDateLabel = intl.formatMessage({
    id: 'Mv8Y8gWWnt',
    defaultMessage: 'Start date',
    description: 'Label for trip item start date',
  })
  const checkOutLabel = intl.formatMessage({
    id: '1fzwUds/yg',
    defaultMessage: 'Check out',
    description: 'Label for accommodation check-out date',
  })
  const endDateLabel = intl.formatMessage({
    id: '/pdvHKFeG9',
    defaultMessage: 'End date',
    description: 'Label for trip item end date',
  })

  return (
    <Dates>
      {startDate && moment(startDate).isValid() && (
        <Date>
          <BodyText variant="medium" weight="bold">
            {isAccommodation ? checkInLabel : startDateLabel}
          </BodyText>
          <BodyText variant="large">
            {startDate.format(SHORT_DAY_NAME_DAY_MONTH_YEAR)}
          </BodyText>
          {startTime && (
            <BodyText variant="large">{startTime.format(timeFormat)}</BodyText>
          )}
        </Date>
      )}
      {endDate && moment(endDate).isValid() && (
        <Date>
          <BodyText variant="medium" weight="bold">
            {isAccommodation ? checkOutLabel : endDateLabel}
          </BodyText>
          <BodyText variant="large">
            {endDate.format(SHORT_DAY_NAME_DAY_MONTH_YEAR)}
          </BodyText>
          {endTime && (
            <BodyText variant="large">{endTime.format(timeFormat)}</BodyText>
          )}
        </Date>
      )}
    </Dates>
  )
}

export default CheckInAndOutDate
